var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"validationObserver"},[_c('b-form',_vm._g(_vm._b({ref:"form"},'b-form',_vm.$attrs,false),_vm.$listeners),[(typeof _vm.form.MeasureTime !== 'undefined')?_c('b-form-group',{attrs:{"id":"MeasureTime","label":_vm.$t('kiosk.MeasureTime'),"label-for":"MeasureTime","label-cols":"3"}},[_c('flat-pickr',{staticClass:"form-control",attrs:{"value":_vm.form.MeasureTime,"config":{
          dateFormat: 'Y-m-d H:i:S',
          time_24hr: true,
          enableTime: true,
          enableSeconds: true,
          minuteIncrement: 1,
        }},on:{"input":_vm.handleMeasureTimeInput}})],1):_vm._e(),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }